import { deleteCalendarEvent } from 'owa-timestream-asset-sdk-calendarevents';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { logSpacesDatapoint } from 'owa-timestream-logging';

export default function deleteGoalEvent(event: Readonly<CalendarEvent>) {
    logSpacesDatapoint('OUTLOOKSPACES_GOAL_DELETE_EVENT');
    return deleteCalendarEvent('SpacesGoalAsset', event).catch(onDeleteGoalEventFailed);
}

function onDeleteGoalEventFailed() {
    logSpacesDatapoint('OUTLOOKSPACES_GOAL_DELETE_EVENT_FAILED');
}
